// extracted by mini-css-extract-plugin
export default {"text":"user-permissions_text__Z0EbT","separator":"user-permissions_separator__p+ajO"};